// import React, { useState, useEffect } from 'react';
// import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
// import axios from 'axios';

// const MetricCard = ({ title, value, count, gradient, showDollarSign = false }) => (
//   <div
//     className={`rounded-lg shadow-md p-6 border border-gray-200 bg-gradient-to-br ${gradient} transition-transform transform hover:scale-105 hover:shadow-lg`}
//   >
//     <div className="flex flex-col">
//       <span className="text-gray-600 text-sm font-medium">{title}</span>
//       <span className="text-2xl font-semibold text-gray-800">
//         {showDollarSign ? '$' : ''}{value?.toLocaleString() || '0'}
//       </span>
//       {count !== undefined && (
//         <span className="text-sm text-gray-500 mt-1">{count} invoices</span>
//       )}
//     </div>
//   </div>
// );

// const TabButton = ({ label, isActive, onClick }) => (
//   <button
//     onClick={onClick}
//     className={`px-6 py-3 font-medium text-sm rounded-md transition-all duration-200 ${
//       isActive
//         ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md"
//         : "text-gray-600 hover:bg-gray-100 hover:text-blue-600"
//     }`}
//   >
//     {label}
//   </button>
// );

// const NewPayment = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [invoiceData, setInvoiceData] = useState(null);
//   const [tabData, setTabData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [tabLoading, setTabLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [activeTab, setActiveTab] = useState('upcoming');

//   const getDefaultDateRange = () => {
//     const today = new Date();
//     const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

//     return {
//       startDate: firstDayOfMonth.toISOString().split('T')[0], // Format as YYYY-MM-DD
//       endDate: today.toISOString().split('T')[0], // Format as YYYY-MM-DD
//     };
//   };
//   const [dateRange, setDateRange] = useState(getDefaultDateRange());

//   // Fetch main invoice summary data
//   useEffect(() => {
//     const fetchInvoiceData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) params.append('year', selectedYear);
//         if (selectedMonth && selectedMonth !== 'All') {
//           const monthAbbrev = selectedMonth.slice(0, 3);
//           params.append('month', monthAbbrev);
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/invoice_summary/${params.toString() ? `?${params.toString()}` : ''}`
//         );

//         if (response.data) {
//           setInvoiceData(response.data);
//           setError(null);
//         }
//       } catch (err) {
//         setError(err.message || 'Failed to fetch invoice data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInvoiceData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   // Fetch tab-specific data
//   useEffect(() => {
//     const fetchTabData = async () => {
//       try {
//         setTabLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) params.append('year', selectedYear);
//         if (selectedMonth && selectedMonth !== 'All') {
//           const monthAbbrev = selectedMonth.slice(0, 3);
//           params.append('month', monthAbbrev);
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }
//         if (activeTab !== 'overdue') {
//           if (dateRange.startDate) params.append('start_date', dateRange.startDate);
//           if (dateRange.endDate) params.append('end_date', dateRange.endDate);
//         }

//         let endpoint = '';
//         switch (activeTab) {
//           case 'upcoming':
//             endpoint = 'upcoming_payments';
//             break;
//           case 'overdue':
//             endpoint = 'overdue_payments';
//             break;
//           case 'paid':
//             endpoint = 'paid_payments';
//             break;
//           default:
//             endpoint = 'upcoming_payments';
//         }

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/${endpoint}/${params.toString() ? `?${params.toString()}` : ''}`
//         );

//         if (response.data) {
//           setTabData(response.data);
//         }
//       } catch (err) {
//         console.error('Failed to fetch tab data:', err);
//       } finally {
//         setTabLoading(false);
//       }
//     };

//     if (activeTab === 'overdue' || (dateRange.startDate && dateRange.endDate)) {
//       fetchTabData();
//     }
//   }, [activeTab, dateRange.startDate, dateRange.endDate, selectedYear, selectedMonth, selectedAdmin]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-gray-500">Loading...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   const summaryCards = [
//     {
//       title: 'Pending Amount',
//       value: invoiceData?.total_pending_amount || 0,
//       gradient: 'from-yellow-100 to-yellow-200',
//       showDollarSign: true
//     },
//     {
//       title: 'Full Paid Invoices',
//       value: invoiceData?.full_paid_invoices?.count || 0,
//       gradient: 'from-green-100 to-green-200',
//       showDollarSign: false
//     },
//     {
//       title: 'Partially Paid Invoices',
//       value: invoiceData?.partially_paid_invoices?.count || 0,
//       gradient: 'from-blue-100 to-blue-200',
//       showDollarSign: false
//     },
//     {
//       title: 'Unpaid Invoices',
//       value: invoiceData?.unpaid_invoices?.count || 0,
//       gradient: 'from-red-100 to-red-200',
//       showDollarSign: false
//     },
//   ];

//   const amountCards = [
//     {
//       title: 'Full Paid Amount',
//       value: invoiceData?.full_paid_invoices?.total_amount || 0,
//       gradient: 'from-green-100 to-green-200',
//       showDollarSign: true
//     },
//     {
//       title: 'Partially Paid Amount',
//       value: invoiceData?.partially_paid_invoices?.total_amount || 0,
//       gradient: 'from-blue-100 to-blue-200',
//       showDollarSign: true
//     },
//     {
//       title: 'Unpaid Amount',
//       value: invoiceData?.unpaid_invoices?.total_amount || 0,
//       gradient: 'from-red-100 to-red-200',
//       showDollarSign: true
//     },
//   ];

//   const pieChartData = [
//     {
//       name: 'Full Paid',
//       value: invoiceData?.full_paid_invoices?.count || 0,
//     },
//     {
//       name: 'Partially Paid',
//       value: invoiceData?.partially_paid_invoices?.count || 0,
//     },
//     {
//       name: 'Unpaid',
//       value: invoiceData?.unpaid_invoices?.count || 0,
//     },
//   ];

//   const PIE_GRADIENTS = [
//     'url(#greenGradient)',
//     'url(#blueGradient)',
//     'url(#redGradient)',
//   ];

//   // Tab content rendering function
//   const renderTabContent = () => {
//     if (tabLoading) {
//       return (
//         <div className="flex justify-center p-4">
//           <div className="text-gray-500">Loading...</div>
//         </div>
//       );
//     }

//     if (!tabData) {
//       return (
//         <div className="flex justify-center p-4">
//           <div className="text-gray-500">
//             {activeTab !== 'overdue' ? 'Please select date range' : 'No data available'}
//           </div>
//         </div>
//       );
//     }

//     const tabCards = [
//       {
//         title: `Total ${activeTab === 'paid' ? 'Paid' : 'Pending'} Invoices`,
//         value: tabData.invoice_count || 0,
//         gradient: 'from-blue-100 to-blue-200',
//         showDollarSign: false
//       },
//       {
//         title: `Total ${activeTab === 'paid' ? 'Paid' : 'Pending'} Amount`,
//         value: activeTab === 'paid' ? tabData.total_paid_amount : tabData.total_pending_amount || 0,
//         gradient: 'from-green-100 to-green-200',
//         showDollarSign: true
//       }
//     ];

//     return (
//       <div className="space-y-6">
//         {/* Tab Summary Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {tabCards.map((card, index) => (
//             <MetricCard key={index} {...card} />
//           ))}
//         </div>

//         {/* Tab Table */}
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Invoice ID
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Customer Name
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Status
//                 </th>
//                 <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   {activeTab === 'paid' ? 'Paid Amount' : 'Pending Amount'}
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {(activeTab === 'paid' ? tabData.invoice_data : tabData.invoices)?.map((invoice) => (
//                 <tr key={invoice.invoice_id}>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600">
//                     {invoice.invoice_id}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     {invoice.customer_name}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm">
//                     <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
//                       ${invoice.status === 'Paid' ? 'bg-green-100 text-green-800' :
//                         invoice.status === 'Overdue' ? 'bg-red-100 text-red-800' :
//                         invoice.status === 'Partially Paid' ? 'bg-blue-100 text-blue-800' :
//                         'bg-yellow-100 text-yellow-800'}`}
//                     >
//                       {invoice.status}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
//                     ${(activeTab === 'paid' ? invoice.paid_amount : invoice.pending_amount)?.toLocaleString()}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//             <tfoot className="bg-gray-50">
//               <tr>
//                 <td colSpan="3" className="px-6 py-3 text-right text-sm font-medium text-gray-500">
//                   Total {activeTab === 'paid' ? 'Paid' : 'Pending'} Amount:
//                 </td>
//                 <td className="px-6 py-3 text-right text-sm font-medium text-gray-900">
//                   ${(activeTab === 'paid' ? tabData.total_paid_amount : tabData.total_pending_amount)?.toLocaleString() || '0'}
//                 </td>
//               </tr>
//             </tfoot>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       {/* Top Status Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6">
//         {summaryCards.map((card, index) => (
//           <MetricCard key={index} {...card} />
//         ))}
//       </div>

//       {/* Amount Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
//         {amountCards.map((card, index) => (
//           <MetricCard key={index} {...card} />
//         ))}
//       </div>

//       {/* Charts and Tabs Section */}
//       <div className="space-y-6">
//         {/* Pie Chart */}
//         <div className="bg-white p-6 rounded-lg shadow-md w-full lg:w-1/2">
//           <h3 className="text-lg font-semibold text-gray-800 mb-4">
//             Invoice Distribution
//           </h3>
//           <ResponsiveContainer width="100%" height={300}>
//             <PieChart>
//               <defs>
//                 <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#4caf50" />
//                   <stop offset="100%" stopColor="#81c784" />
//                 </linearGradient>
//                 <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#2196f3" />
//                   <stop offset="100%" stopColor="#64b5f6" />
//                 </linearGradient>
//                 <linearGradient id="redGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#f44336" />
//                   <stop offset="100%" stopColor="#e57373" />
//                 </linearGradient>
//               </defs>
//               <Pie
//                 data={pieChartData}
//                 cx="50%"
//                 cy="50%"
//                 labelLine={false}
//                 outerRadius={80}
//                 dataKey="value"
//               >
//                 {pieChartData.map((entry, index) => (
//                   <Cell key={`cell-${index}`} fill={PIE_GRADIENTS[index % PIE_GRADIENTS.length]} />
//                 ))}
//               </Pie>
//               <Tooltip />
//               <Legend />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>

//         {/* Tab and Date Selection Section - Full Width */}
//         <div className="bg-white px-6 py-4 rounded-lg shadow-md w-full">
//           {/* Tab Navigation */}
//           <div className="flex space-x-4 mb-6">
//             <TabButton
//               label="Upcoming"
//               isActive={activeTab === 'upcoming'}
//               onClick={() => setActiveTab('upcoming')}
//             />
//             <TabButton
//               label="Paid"
//               isActive={activeTab === 'paid'}
//               onClick={() => setActiveTab('paid')}
//             />
//             <TabButton
//               label="Overdue"
//               isActive={activeTab === 'overdue'}
//               onClick={() => setActiveTab('overdue')}
//             />
//           </div>

//           {/* Date Selection - Hidden for Overdue tab */}
//           {activeTab !== 'overdue' && (
//             <div className="grid grid-cols-2 gap-6 max-w-2xl mb-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Start Date
//                 </label>
//                 <input
//                   type="date"
//                   className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                   onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))}
//                   placeholder="dd-mm-yyyy"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   End Date
//                 </label>
//                 <input
//                   type="date"
//                   className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                   onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))}
//                   placeholder="dd-mm-yyyy"
//                 />
//               </div>
//             </div>
//           )}

//           {/* Tab Content */}
//           {renderTabContent()}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewPayment;

// import React, { useState, useEffect } from 'react';
// import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
// import axios from 'axios';

// const MetricCard = ({ title, value, count, gradient, showDollarSign = false }) => (
//   <div
//     className={`rounded-lg shadow-md p-6 border border-gray-200 bg-gradient-to-br ${gradient} transition-transform transform hover:scale-105 hover:shadow-lg`}
//   >
//     <div className="flex flex-col">
//       <span className="text-gray-600 text-sm font-medium">{title}</span>
//       <span className="text-2xl font-semibold text-gray-800">
//         {showDollarSign ? '$' : ''}{value?.toLocaleString() || '0'}
//       </span>
//       {count !== undefined && (
//         <span className="text-sm text-gray-500 mt-1">{count} invoices</span>
//       )}
//     </div>
//   </div>
// );

// const TabButton = ({ label, isActive, onClick }) => (
//   <button
//     onClick={onClick}
//     className={`px-6 py-3 font-medium text-sm rounded-md transition-all duration-200 ${
//       isActive
//         ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md"
//         : "text-gray-600 hover:bg-gray-100 hover:text-blue-600"
//     }`}
//   >
//     {label}
//   </button>
// );

// const NewPayment = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [invoiceData, setInvoiceData] = useState(null);
//   const [tabData, setTabData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [tabLoading, setTabLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [activeTab, setActiveTab] = useState('upcoming');
//   const [dateRange, setDateRange] = useState({
//     startDate: new Date().toISOString().split('T')[0],
//     endDate: new Date().toISOString().split('T')[0],
//   });

//   // Fetch main invoice summary data
//   useEffect(() => {
//     const fetchInvoiceData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();
//         if (selectedYear) params.append('year', selectedYear);
//         if (selectedMonth && selectedMonth !== 'All') {
//           const monthAbbrev = selectedMonth.slice(0, 3);
//           params.append('month', monthAbbrev);
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/invoice_summary/${params.toString() ? `?${params.toString()}` : ''}`
//         );
// "invoiceData",response);

//         if (response.data) {
//           setInvoiceData(response.data);
//           setError(null);
//         }
//       } catch (err) {
//         setError(err.message || 'Failed to fetch invoice data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInvoiceData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   // Fetch tab-specific data
//   useEffect(() => {
//     const fetchTabData = async () => {
//       try {
//         setTabLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) params.append('year', selectedYear);
//         if (selectedMonth && selectedMonth !== 'All') {
//           const monthAbbrev = selectedMonth.slice(0, 3);
//           params.append('month', monthAbbrev);
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }
//         if (activeTab !== 'overdue') {
//           if (dateRange.startDate) params.append('start_date', dateRange.startDate);
//           if (dateRange.endDate) params.append('end_date', dateRange.endDate);
//         }

//         let endpoint = '';
//         switch (activeTab) {
//           case 'upcoming':
//             endpoint = 'upcoming_payments';
//             break;
//           case 'overdue':
//             endpoint = 'overdue_payments';
//             break;
//           case 'paid':
//             endpoint = 'paid_payments';
//             break;
//           default:
//             endpoint = 'upcoming_payments';
//         }

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/${endpoint}/${params.toString() ? `?${params.toString()}` : ''}`
//         );

//         if (response.data) {
//           setTabData(response.data);
//         }
//       } catch (err) {
//         console.error('Failed to fetch tab data:', err);
//       } finally {
//         setTabLoading(false);
//       }
//     };

//     if (activeTab === 'overdue' || (dateRange.startDate && dateRange.endDate)) {
//       fetchTabData();
//     }
//   }, [activeTab, dateRange.startDate, dateRange.endDate, selectedYear, selectedMonth, selectedAdmin]);

// const renderTabContent = () => {
//   if (tabLoading) {
//     return (
//       <div className="flex justify-center p-4">
//         <div className="text-gray-500">Loading...</div>
//       </div>
//     );
//   }

//   if (!tabData) {
//     return (
//       <div className="flex justify-center p-4">
//         <div className="text-gray-500">
//           {activeTab !== 'overdue' ? 'Please select date range' : 'No data available'}
//         </div>
//       </div>
//     );
//   }

//   const tabCards = [
//     {
//       title: `Total ${activeTab === 'paid' ? 'Paid' : 'Pending'} Invoices`,
//       value: tabData.invoice_count || 0,
//       gradient: 'from-blue-100 to-blue-200',
//       showDollarSign: false
//     },
//     {
//       title: `Total ${activeTab === 'paid' ? 'Paid' : 'Pending'} Amount`,
//       value: activeTab === 'paid' ? tabData.total_paid_amount : tabData.total_pending_amount || 0,
//       gradient: 'from-green-100 to-green-200',
//       showDollarSign: true
//     }
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         {tabCards.map((card, index) => (
//           <MetricCard key={index} {...card} />
//         ))}
//       </div>

//       <div className="overflow-x-auto">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Invoice ID
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Customer Name
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Status
//               </th>
//               {activeTab === 'overdue' && (
//                 <>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Due Date
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Contact Number
//                   </th>
//                 </>
//               )}
//               <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 {activeTab === 'paid' ? 'Paid Amount' : 'Pending Amount'}
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {(activeTab === 'paid' ? tabData.invoice_data : tabData.invoices)?.map((invoice) => (
//               <tr key={invoice.invoice_id}>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600">
//                   {invoice.invoice_id}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                   {invoice.customer_name}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm">
//                   <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
//                     ${invoice.status === 'Paid' ? 'bg-green-100 text-green-800' :
//                       invoice.status === 'Overdue' ? 'bg-red-100 text-red-800' :
//                       invoice.status === 'Partially Paid' ? 'bg-blue-100 text-blue-800' :
//                       'bg-yellow-100 text-yellow-800'}`}
//                   >
//                     {invoice.status}
//                   </span>
//                 </td>
//                 {activeTab === 'overdue' && (
//                   <>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                       {invoice.due_date}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                       {invoice.contact_number || 'N/A'}
//                     </td>
//                   </>
//                 )}
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
//                   ${(activeTab === 'paid' ? invoice.paid_amount : invoice.pending_amount)?.toLocaleString()}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//           <tfoot className="bg-gray-50">
//             <tr>
//               <td colSpan={activeTab === 'overdue' ? '5' : '3'} className="px-6 py-3 text-right text-sm font-medium text-gray-500">
//                 Total {activeTab === 'paid' ? 'Paid' : 'Pending'} Amount:
//               </td>
//               <td className="px-6 py-3 text-right text-sm font-medium text-gray-900">
//                 ${(activeTab === 'paid' ? tabData.total_paid_amount : tabData.total_pending_amount)?.toLocaleString() || '0'}
//               </td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>
//     </div>
//   );
// };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-gray-500">Loading...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   const summaryCards = [
//     {
//       title: 'Pending Amount',
//       value: invoiceData?.total_pending_amount || 0,
//       gradient: 'from-yellow-100 to-yellow-200',
//       showDollarSign: true
//     },
//     {
//       title: 'Full Paid Invoices',
//       value: invoiceData?.full_paid_invoices?.count || 0,
//       gradient: 'from-green-100 to-green-200',
//       showDollarSign: false
//     },
//     {
//       title: 'Partially Paid Invoices',
//       value: invoiceData?.partially_paid_invoices?.count || 0,
//       gradient: 'from-blue-100 to-blue-200',
//       showDollarSign: false
//     },
//     {
//       title: 'Unpaid Invoices',
//       value: invoiceData?.unpaid_invoices?.count || 0,
//       gradient: 'from-red-100 to-red-200',
//       showDollarSign: false
//     },
//   ];

//   const amountCards = [
//     {
//       title: 'Full Paid Amount',
//       value: invoiceData?.full_paid_invoices?.total_amount || 0,
//       gradient: 'from-green-100 to-green-200',
//       showDollarSign: true
//     },
//     {
//       title: 'Partially Paid Amount',
//       value: invoiceData?.partially_paid_invoices?.total_amount || 0,
//       gradient: 'from-blue-100 to-blue-200',
//       showDollarSign: true
//     },
//     {
//       title: 'Unpaid Amount',
//       value: invoiceData?.unpaid_invoices?.total_amount || 0,
//       gradient: 'from-red-100 to-red-200',
//       showDollarSign: true
//     },
//   ];

//   const pieChartData = [
//     {
//       name: 'Full Paid',
//       value: invoiceData?.full_paid_invoices?.count || 0,
//     },
//     {
//       name: 'Partially Paid',
//       value: invoiceData?.partially_paid_invoices?.count || 0,
//     },
//     {
//       name: 'Unpaid',
//       value: invoiceData?.unpaid_invoices?.count || 0,
//     },
//   ];

//   const PIE_GRADIENTS = [
//     'url(#greenGradient)',
//     'url(#blueGradient)',
//     'url(#redGradient)',
//   ];

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       {/* Top Status Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6">
//         {summaryCards.map((card, index) => (
//           <MetricCard key={index} {...card} />
//         ))}
//       </div>

//       {/* Amount Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
//         {amountCards.map((card, index) => (
//           <MetricCard key={index} {...card} />
//         ))}
//       </div>

//       {/* Charts and Tabs Section */}
//       <div className="space-y-6">
//         {/* Pie Chart */}
//         <div className="bg-white p-6 rounded-lg shadow-md w-full lg:w-1/2">
//           <h3 className="text-lg font-semibold text-gray-800 mb-4">
//             Invoice Distribution
//           </h3>
//           <ResponsiveContainer width="100%" height={300}>
//             <PieChart>
//               <defs>
//                 <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#4caf50" />
//                   <stop offset="100%" stopColor="#81c784" />
//                 </linearGradient>
//                 <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#2196f3" />
//                   <stop offset="100%" stopColor="#64b5f6" />
//                 </linearGradient>
//                 <linearGradient id="redGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#f44336" />
//                   <stop offset="100%" stopColor="#e57373" />
//                 </linearGradient>
//               </defs>
//               <Pie
//                 data={pieChartData}
//                 cx="50%"
//                 cy="50%"
//                 labelLine={false}
//                 outerRadius={80}
//                 dataKey="value"
//               >
//                 {pieChartData.map((entry, index) => (
//                   <Cell key={`cell-${index}`} fill={PIE_GRADIENTS[index % PIE_GRADIENTS.length]} />
//                 ))}
//               </Pie>
//               <Tooltip />
//               <Legend />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>

//         {/* Tab and Date Selection Section */}
//         <div className="bg-white px-6 py-4 rounded-lg shadow-md w-full">
//           {/* Tab Navigation */}
//           <div className="flex space-x-4 mb-6">
//             <TabButton
//               label="Upcoming"
//               isActive={activeTab === 'upcoming'}
//               onClick={() => setActiveTab('upcoming')}
//             />
//             <TabButton
//               label="Paid"
//               isActive={activeTab === 'paid'}
//               onClick={() => setActiveTab('paid')}
//             />
//             <TabButton
//               label="Overdue"
//               isActive={activeTab === 'overdue'}
//               onClick={() => setActiveTab('overdue')}
//             />
//           </div>

//           {/* Date Selection - Hidden for Overdue tab */}
//           {activeTab !== 'overdue' && (
//             <div className="grid grid-cols-2 gap-6 max-w-2xl mb-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Start Date
//                 </label>
//                 <input
//                   type="date"
//                   className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                   value={dateRange.startDate}
//                   onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))}
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   End Date
//                 </label>
//                 <input
//                   type="date"
//                   className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                   value={dateRange.endDate}
//                   onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))}
//                 />
//               </div>
//             </div>
//           )}

//           {/* Tab Content */}
//           {renderTabContent()}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewPayment;

import React, { useState, useEffect } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import axios from "axios";
import * as XLSX from "xlsx";

const MetricCard = ({
  title,
  value,
  count,
  gradient,
  showDollarSign = false,
}) => (
  <div
    className={`rounded-lg shadow-md p-6 border border-gray-200 bg-gradient-to-br ${gradient} transition-transform transform hover:scale-105 hover:shadow-lg`}
  >
    <div className="flex flex-col">
      <span className="text-gray-600 text-sm font-medium">{title}</span>
      <span className="text-2xl font-semibold text-gray-800">
        {showDollarSign ? "₹" : ""}
        {value?.toLocaleString() || "0"}
      </span>
      {count !== undefined && (
        <span className="text-sm text-gray-500 mt-1">{count} invoices</span>
      )}
    </div>
  </div>
);

const TabButton = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium text-sm rounded-md transition-all duration-200 ${
      isActive
        ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md"
        : "text-gray-600 hover:bg-gray-100 hover:text-blue-600"
    }`}
  >
    {label}
  </button>
);

const InvoiceTable = ({ isVisible, onClose }) => {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  const fetchTableData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/invoice_price/api/invoices/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setTableData(response.data);
    } catch (error) {
      setError(error.response?.data?.detail || "Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      fetchTableData();
    }
  }, [isVisible]);

  // Function to export table data to Excel
  const exportToExcel = async () => {
    try {
      setIsExporting(true);

      // Create worksheet from table data
      const worksheet = XLSX.utils.json_to_sheet(
        tableData.map((invoice) => ({
          ID: invoice.id,
          "Customer Name": invoice.customer?.name || "-",
          Email: invoice.customer?.email || "-",
          "Service Name": invoice.items?.[0]?.service_name || "-",
          Status: invoice.status || "-",
          Amount: Number(invoice.total_amount).toFixed(2) || "0.00",
        }))
      );

      // Format the cells
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let c = 0; c <= range.e.c; c++) {
        const col = XLSX.utils.encode_col(c);
        for (let r = 0; r <= range.e.r; r++) {
          const row = r + 1;
          const cell = worksheet[col + row];

          // Set column widths
          if (!worksheet["!cols"]) worksheet["!cols"] = [];
          if (!worksheet["!cols"][c]) worksheet["!cols"][c] = { wch: 15 };

          // Format headers (first row)
          if (r === 0) {
            if (!cell.s) cell.s = {};
            cell.s.font = { bold: true };
            cell.s.fill = { fgColor: { rgb: "EFEFEF" } };
          }
        }
      }

      // Create workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

      // Generate filename with current date
      const dateStr = new Date().toISOString().split("T")[0];
      const fileName = `Invoice_Data_${dateStr}.xlsx`;

      // Generate and download Excel file
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Failed to export data to Excel:", error);
    } finally {
      setIsExporting(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-11/12 shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-800">
            Invoice Details
          </h3>
          <div className="flex space-x-2">
            <button
              onClick={exportToExcel}
              disabled={isExporting || tableData.length === 0}
              className={`px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors flex items-center space-x-1 ${
                isExporting || tableData.length === 0
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              {isExporting ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Exporting...</span>
                </>
              ) : (
                <>
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    ></path>
                  </svg>
                  <span>Export to Excel</span>
                </>
              )}
            </button>
            <button
              onClick={fetchTableData}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Refresh
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="text-gray-600">Loading...</div>
          </div>
        ) : error ? (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-600">{error}</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    ID
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Customer Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Service Name
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {tableData.map((invoice) => (
                  <tr key={invoice.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {invoice.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {invoice.customer?.name || "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600 hover:text-blue-800">
                      {invoice.customer?.email || "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {invoice.items?.[0]?.service_name || "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                        ${
                          invoice.status === "Paid"
                            ? "bg-green-100 text-green-800"
                            : invoice.status === "Overdue"
                            ? "bg-red-100 text-red-800"
                            : invoice.status === "Partially Paid"
                            ? "bg-blue-100 text-blue-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {invoice.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
                      ₹
                      {Number(invoice.total_amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
const NewPayment = ({ selectedYear, selectedMonth, selectedAdmin }) => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [tabData, setTabData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabLoading, setTabLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("upcoming");
  const [showInvoiceTable, setShowInvoiceTable] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  });

  // Fetch main invoice summary data
  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();
        if (selectedYear) params.append("year", selectedYear);
        if (selectedMonth && selectedMonth !== "All") {
          const monthAbbrev = selectedMonth.slice(0, 3);
          params.append("month", monthAbbrev);
        }
        if (selectedAdmin && selectedAdmin !== "all") {
          params.append("created_by", selectedAdmin);
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/dashboard/api/invoice_summary/${
            params.toString() ? `?${params.toString()}` : ""
          }`
        );

        if (response.data) {
          setInvoiceData(response.data);
          setError(null);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch invoice data");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoiceData();
  }, [selectedYear, selectedMonth, selectedAdmin]);

  // Your existing fetchTabData useEffect...
  useEffect(() => {
    const fetchTabData = async () => {
      try {
        setTabLoading(true);
        const params = new URLSearchParams();

        if (selectedYear) params.append("year", selectedYear);
        if (selectedMonth && selectedMonth !== "All") {
          const monthAbbrev = selectedMonth.slice(0, 3);
          params.append("month", monthAbbrev);
        }
        if (selectedAdmin && selectedAdmin !== "all") {
          params.append("created_by", selectedAdmin);
        }
        if (activeTab !== "overdue") {
          if (dateRange.startDate)
            params.append("start_date", dateRange.startDate);
          if (dateRange.endDate) params.append("end_date", dateRange.endDate);
        }

        let endpoint = "";
        switch (activeTab) {
          case "upcoming":
            endpoint = "upcoming_payments";
            break;
          case "overdue":
            endpoint = "overdue_payments";
            break;
          case "paid":
            endpoint = "paid_payments";
            break;
          default:
            endpoint = "upcoming_payments";
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/dashboard/api/${endpoint}/${
            params.toString() ? `?${params.toString()}` : ""
          }`
        );

        if (response.data) {
          setTabData(response.data);
        }
      } catch (err) {
        console.error("Failed to fetch tab data:", err);
      } finally {
        setTabLoading(false);
      }
    };

    if (activeTab === "overdue" || (dateRange.startDate && dateRange.endDate)) {
      fetchTabData();
    }
  }, [
    activeTab,
    dateRange.startDate,
    dateRange.endDate,
    selectedYear,
    selectedMonth,
    selectedAdmin,
  ]);

  // Your existing renderTabContent function...
  //   const renderTabContent = () => {
  //     if (tabLoading) {
  //       return (
  //         <div className="flex justify-center p-4">
  //           <div className="text-gray-500">Loading...</div>
  //         </div>
  //       );
  //     }

  //     if (!tabData) {
  //       return (
  //         <div className="flex justify-center p-4">
  //           <div className="text-gray-500">
  //             {activeTab !== 'overdue' ? 'Please select date range' : 'No data available'}
  //           </div>
  //         </div>
  //       );
  //     }

  //     const tabCards = [
  //       {
  //         title: `Total ${activeTab === 'paid' ? 'Paid' : 'Pending'} Invoices`,
  //         value: tabData.invoice_count || 0,
  //         gradient: 'from-blue-100 to-blue-200',
  //         showDollarSign: false
  //       },
  //       {
  //         title: `Total ${activeTab === 'paid' ? 'Paid' : 'Pending'} Amount`,
  //         value: activeTab === 'paid' ? tabData.total_paid_amount : tabData.total_pending_amount || 0,
  //         gradient: 'from-green-100 to-green-200',
  //         showDollarSign: true
  //       }
  //     ];

  //     return (
  //       <div className="space-y-6">
  //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  //           {tabCards.map((card, index) => (
  //             <MetricCard key={index} {...card} />
  //           ))}
  //         </div>

  //         <div className="overflow-x-auto">
  //   <table className="min-w-full divide-y divide-gray-200">
  //     <thead className="bg-gray-50">
  //       <tr>
  //         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
  //           Invoice ID
  //         </th>
  //         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
  //           Customer Name
  //         </th>
  //         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
  //           Contact Number
  //         </th>
  //         <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
  //           Status
  //         </th>
  //         <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //           Amount
  //         </th>
  //       </tr>
  //     </thead>
  //     <tbody className="bg-white divide-y divide-gray-200">
  //       {(activeTab === 'paid' ? tabData.invoice_data : tabData.invoices)?.map((invoice) => (
  //         <tr key={invoice.id} className="hover:bg-gray-50">
  //           <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600">
  //             {`INV-${invoice.invoice_id || 'AARA' + invoice.id}`}
  //           </td>
  //           <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
  //             {invoice.customer?.name || invoice.customer_name || '-'}
  //           </td>
  //           <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
  //             {invoice.customer?.phone || invoice.customer?.contact_number || '-'}
  //           </td>
  //           <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
  //             <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
  //               ${invoice.status === 'Paid' ? 'bg-green-100 text-green-800' :
  //                 invoice.status === 'Overdue' ? 'bg-red-100 text-red-800' :
  //                 invoice.status === 'Partially Paid' ? 'bg-blue-100 text-blue-800' :
  //                 'bg-yellow-100 text-yellow-800'}`}
  //             >
  //               {invoice.status}
  //             </span>
  //           </td>
  //           <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
  //             ₹{activeTab === 'paid' ?
  //               Number(invoice.paid_amount || 0).toLocaleString(undefined, {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2
  //               }) :
  //               Number(invoice.pending_amount || 0).toLocaleString(undefined, {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2
  //               })}
  //           </td>
  //         </tr>
  //       ))}
  //     </tbody>
  //   </table>
  // </div>
  //       </div>
  //     );
  //   };
  const renderTabContent = () => {
    if (tabLoading) {
      return (
        <div className="flex justify-center p-4">
          <div className="text-gray-500">Loading...</div>
        </div>
      );
    }

    if (!tabData) {
      return (
        <div className="flex justify-center p-4">
          <div className="text-gray-500">
            {activeTab !== "overdue"
              ? "Please select date range"
              : "No data available"}
          </div>
        </div>
      );
    }

    const tabCards = [
      {
        title: `Total ${activeTab === "paid" ? "Paid" : "Pending"} Invoices`,
        value: tabData.invoice_count || 0,
        gradient: "from-blue-100 to-blue-200",
        showDollarSign: false,
      },
      {
        title: `Total ${activeTab === "paid" ? "Paid" : "Pending"} Amount`,
        value:
          activeTab === "paid"
            ? tabData.total_paid_amount
            : tabData.total_pending_amount || 0,
        gradient: "from-green-100 to-green-200",
        showDollarSign: true,
      },
    ];

    return (
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {tabCards.map((card, index) => (
            <MetricCard key={index} {...card} />
          ))}
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Invoice ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Customer Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                {activeTab === "overdue" && (
                  <>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Due Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Contact Number
                    </th>
                  </>
                )}
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {activeTab === "paid" ? "Paid Amount" : "Pending Amount"}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {(activeTab === "paid"
                ? tabData.invoice_data
                : tabData.invoices
              )?.map((invoice) => (
                <tr key={invoice.invoice_id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600">
                    {invoice.invoice_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {invoice.customer_name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                    ${
                      invoice.status === "Paid"
                        ? "bg-green-100 text-green-800"
                        : invoice.status === "Overdue"
                        ? "bg-red-100 text-red-800"
                        : invoice.status === "Partially Paid"
                        ? "bg-blue-100 text-blue-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                    >
                      {invoice.status}
                    </span>
                  </td>
                  {activeTab === "overdue" && (
                    <>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {invoice.due_date}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {invoice.contact_number || "N/A"}
                      </td>
                    </>
                  )}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
                    ₹
                    {(activeTab === "paid"
                      ? invoice.paid_amount
                      : invoice.pending_amount
                    )?.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-gray-50">
              <tr>
                <td
                  colSpan={activeTab === "overdue" ? "5" : "3"}
                  className="px-6 py-3 text-right text-sm font-medium text-gray-500"
                >
                  Total {activeTab === "paid" ? "Paid" : "Pending"} Amount:
                </td>
                <td className="px-6 py-3 text-right text-sm font-medium text-gray-900">
                  ₹
                  {(activeTab === "paid"
                    ? tabData.total_paid_amount
                    : tabData.total_pending_amount
                  )?.toLocaleString() || "0"}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-red-500">Error: {error}</div>
      </div>
    );
  }
  const summaryCards = [
    {
      title: "Pending Amount",
      value: invoiceData?.total_pending_amount || 0,
      gradient: "from-yellow-100 to-yellow-200",
      showDollarSign: true,
    },
    {
      title: "Full Paid Invoices",
      value: invoiceData?.full_paid_invoices?.count || 0,
      gradient: "from-green-100 to-green-200",
      showDollarSign: false,
    },
    {
      title: "Partially Paid Invoices",
      value: invoiceData?.partially_paid_invoices?.count || 0,
      gradient: "from-blue-100 to-blue-200",
      showDollarSign: false,
    },
    {
      title: "Unpaid Invoices",
      value: invoiceData?.unpaid_invoices?.count || 0,
      gradient: "from-red-100 to-red-200",
      showDollarSign: false,
    },
  ];

  const amountCards = [
    {
      title: "Full Paid Amount",
      value: invoiceData?.full_paid_invoices?.total_amount || 0,
      gradient: "from-green-100 to-green-200",
      showDollarSign: true,
    },
    {
      title: "Partially Paid Amount",
      value: invoiceData?.partially_paid_invoices?.total_amount || 0,
      gradient: "from-blue-100 to-blue-200",
      showDollarSign: true,
    },
    {
      title: "Unpaid Amount",
      value: invoiceData?.unpaid_invoices?.total_amount || 0,
      gradient: "from-red-100 to-red-200",
      showDollarSign: true,
    },
  ];

  const pieChartData = [
    {
      name: "Full Paid",
      value: invoiceData?.full_paid_invoices?.count || 0,
    },
    {
      name: "Partially Paid",
      value: invoiceData?.partially_paid_invoices?.count || 0,
    },
    {
      name: "Unpaid",
      value: invoiceData?.unpaid_invoices?.count || 0,
    },
  ];

  const PIE_GRADIENTS = [
    "url(#greenGradient)",
    "url(#blueGradient)",
    "url(#redGradient)",
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Top Status Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6">
        {summaryCards.map((card, index) => (
          <MetricCard key={index} {...card} />
        ))}
      </div>

      {/* Amount Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {amountCards.map((card, index) => (
          <MetricCard key={index} {...card} />
        ))}
      </div>

      {/* Charts and Tabs Section */}
      <div className="space-y-6">
        {/* Pie Chart */}
        <div className="bg-white p-6 rounded-lg shadow-md w-full lg:w-1/2">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Invoice Distribution
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <defs>
                <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#4caf50" />
                  <stop offset="100%" stopColor="#81c784" />
                </linearGradient>
                <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#2196f3" />
                  <stop offset="100%" stopColor="#64b5f6" />
                </linearGradient>
                <linearGradient id="redGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#f44336" />
                  <stop offset="100%" stopColor="#e57373" />
                </linearGradient>
              </defs>
              <Pie
                data={pieChartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                dataKey="value"
              >
                {pieChartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={PIE_GRADIENTS[index % PIE_GRADIENTS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Tab and Date Selection Section */}
        <div className="bg-white px-6 py-4 rounded-lg shadow-md w-full">
          {/* Tab Navigation with Show All Invoices button */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex space-x-4">
              <TabButton
                label="Upcoming"
                isActive={activeTab === "upcoming"}
                onClick={() => setActiveTab("upcoming")}
              />
              <TabButton
                label="Paid"
                isActive={activeTab === "paid"}
                onClick={() => setActiveTab("paid")}
              />
              <TabButton
                label="Overdue"
                isActive={activeTab === "overdue"}
                onClick={() => setActiveTab("overdue")}
              />
            </div>
            <button
              onClick={() => setShowInvoiceTable(true)}
              className="px-6 py-3 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-md shadow-md hover:shadow-lg transition-all duration-200"
            >
              Show All Invoices
            </button>
          </div>

          {/* Date Selection - Hidden for Overdue tab */}
          {activeTab !== "overdue" && (
            <div className="grid grid-cols-2 gap-6 max-w-2xl mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Start Date
                </label>
                <input
                  type="date"
                  className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  value={dateRange.startDate}
                  onChange={(e) =>
                    setDateRange((prev) => ({
                      ...prev,
                      startDate: e.target.value,
                    }))
                  }
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  End Date
                </label>
                <input
                  type="date"
                  className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  value={dateRange.endDate}
                  onChange={(e) =>
                    setDateRange((prev) => ({
                      ...prev,
                      endDate: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          )}

          {/* Tab Content */}
          {renderTabContent()}
        </div>
      </div>

      {/* Invoice Table Modal */}
      <InvoiceTable
        isVisible={showInvoiceTable}
        onClose={() => setShowInvoiceTable(false)}
      />
    </div>
  );
};

export default NewPayment;
